import React, { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { useMerchant } from '../../contexts/MerchantContext';
import { PortalPath } from '../../util/constants';
import { buildUrlWithMerchantId } from '../../util/helpers';

export interface MerchantAwareLinkProps extends Omit<LinkProps, 'to'> {
  /**
   * The path to navigate to. Will automatically include merchantId in search params if not already present.
   */
  to: `${PortalPath}?${string}` | PortalPath;
}

/**
 * A wrapper around react-router-dom's Link component that keeps the merchantId in the search params
 */
export const MerchantAwareLink = forwardRef<HTMLAnchorElement, MerchantAwareLinkProps>(
  ({ to, ...props }, ref) => {
    const { merchantId } = useMerchant();

    return <Link {...props} ref={ref} to={buildUrlWithMerchantId(to, merchantId)} />;
  },
);

MerchantAwareLink.displayName = 'MerchantAwareLink';
